class NewsletterPopup extends HTMLElement {
  static CLOSE_COUNT_COOKIE = "newsletter-popup-close-count";

  constructor() {
    super();

    // Instance state
    this._positionToShow = null;

    // DOM nodes (assigned in connectedCallback)
    this.discountCodeEl = null;
    this.discountCopiedEl = null;
    this.legalCheckbox = null;
    this.submitButton = null;
    this.successContainer = null;

    // Bound event handlers (registered in connectedCallback)
    this._onPopupClick = this.onPopupClick.bind(this);
    this._onScroll = this.onScroll.bind(this);
    this._onLegalChange = this.onLegalChange.bind(this);
    this._onDiscountClick = this.onDiscountClick.bind(this);
  }

  getCloseCount() {
    const match = document.cookie.match(
      new RegExp(`(?:^|; )${NewsletterPopup.CLOSE_COUNT_COOKIE}=([^;]*)`)
    );
    return parseInt(match ? match[1] : "0", 10) || 0;
  }

  setCloseCount(count) {
    document.cookie = `${NewsletterPopup.CLOSE_COUNT_COOKIE}=${count}; path=/; SameSite=Lax`;
  }

  connectedCallback() {
    localStorage.removeItem(NewsletterPopup.CLOSE_COUNT_COOKIE);

    this.discountCodeEl = this.querySelector(".nwct-success__discount-code");
    this.discountCopiedEl = this.querySelector(".nwct-success__discount-code-copied");
    this.legalCheckbox = this.querySelector("#nwct-legal-check");
    this.submitButton = this.querySelector(".newsletter-popup-form__field-wrapper .field__button");
    this.successContainer = this.querySelector(".nwct-success");

    this._positionToShow = window.innerHeight * 0.75;

    this.addEventListener("click", this._onPopupClick);

    if (this.discountCodeEl) {
      this.discountCodeEl.addEventListener("click", this._onDiscountClick);
    }

    if (this.legalCheckbox) {
      this.legalCheckbox.addEventListener("change", this._onLegalChange);
    }

    if (this.successContainer) {
      this.open();
    }

    window.addEventListener("scroll", this._onScroll);
  }

  disconnectedCallback() {
    this.removeEventListener("click", this._onPopupClick);
    window.removeEventListener("scroll", this._onScroll);

    if (this.discountCodeEl) {
      this.discountCodeEl.removeEventListener("click", this._onDiscountClick);
    }

    if (this.legalCheckbox) {
      this.legalCheckbox.removeEventListener("change", this._onLegalChange);
    }
  }

  async onDiscountClick() {
    try {
      await navigator.clipboard.writeText(this.discountCodeEl.textContent);
      this.discountCopiedEl.classList.remove("hidden");
    } catch (err) {
      console.error("Failed to copy text: ", err);
    }
    setTimeout(() => {
      this.discountCopiedEl.classList.add("hidden");
    }, 2000);
  }

  onLegalChange(event) {
    if (event.currentTarget.checked) {
      this.submitButton.disabled = false;
    } else {
      this.submitButton.disabled = true;
    }
  }

  onScroll() {
    if (this._positionToShow < window.scrollY && this.getCloseCount() < 1 && !this.successContainer) {
      this.open();
    }
  }

  onPopupClick(event) {
    if (!event.target.closest(".newsletter-popup") || event.target.closest(".newsletter-popup__close")) {
      this.close();
    }
  }

  open() {
    this.classList.add("open");
  }

  close() {
    this.classList.remove("open");
    this.setCloseCount(this.getCloseCount() + 1);
  }
}

customElements.define("newsletter-popup", NewsletterPopup);